'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _hudlBase = require('hudl-base');

var _actionCreators = require('../../store/actions/action-creators');

var _feedUserUtil = require('../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _feedUserType = require('../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _connectedTagDetailsModal = require('./connected-tag-details-modal');

var _connectedTagDetailsModal2 = _interopRequireDefault(_connectedTagDetailsModal);

var _tagSummary = require('./tag-summary');

var _tagSummary2 = _interopRequireDefault(_tagSummary);

var _logValues = require('../../shared/logging/log-values');

var _loggingUtil = require('../../utils/logging-util');

var _urls = require('../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

var _propTypes = require('../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

require('./_tags.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultLogData = {
  app: _logValues.WEB_APP
};

var ConnectedTags = function (_PureComponent) {
  _inherits(ConnectedTags, _PureComponent);

  function ConnectedTags(props) {
    _classCallCheck(this, ConnectedTags);

    var _this = _possibleConstructorReturn(this, (ConnectedTags.__proto__ || Object.getPrototypeOf(ConnectedTags)).call(this, props));

    _this.onShowOthers = function (e) {
      e.preventDefault();

      if (!_this.props.taggedUsersModalEnabled) {
        return;
      }

      _this.setState({
        showDetailsModal: true
      });

      var logData = _this.state.logData;
      var feedContentId = _this.props.feedContentId;

      // UsageLogEvent converts keys to PascalCase

      var usageLogData = {
        op: 'AllTags',
        func: 'Click'
      };

      if (logData[_logValues.ORIGIN_KEY]) {
        usageLogData.origin = logData[_logValues.ORIGIN_KEY];
      }

      // We want to change TeamProfile, AthleteProfile, AuthorProfile, etc. to just be Profile
      // MiniProfile is an exception as it's not a profile type
      if (usageLogData.origin && usageLogData.origin.indexOf('Profile') !== -1 && usageLogData.origin !== 'MiniProfile') {
        usageLogData.origin = 'Profile';
      }

      if (feedContentId) {
        usageLogData.feedContentId = feedContentId;
      }

      new _hudlBase.UsageLogEvent({
        logger: 'Feed',
        data: usageLogData
      }).log();
    };

    _this.onHideOthers = function () {
      _this.setState({
        showDetailsModal: false
      });
    };

    _this.state = {
      showDetailsModal: false,
      logData: _this.createLogData({}, props)
    };
    return _this;
  }

  _createClass(ConnectedTags, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var communityContentIdObject = this.props.communityContentIdObject;

      this.props.fetchCurrentUserDetailsIfNeeded();
      this.props.fetchCommunityContentMetadataIfNeeded(communityContentIdObject.type, communityContentIdObject.relatedId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        logData: this.createLogData(this.state.logData, nextProps)
      });

      var communityContentIdObject = nextProps.communityContentIdObject,
          taggedUsersModalEnabled = nextProps.taggedUsersModalEnabled;

      if (!taggedUsersModalEnabled) {
        this.props.fetchTagUsersIfNeeded(communityContentIdObject.type, communityContentIdObject.relatedId);
      }
    }
  }, {
    key: 'createLogData',
    value: function createLogData(currentLogData, newProps) {
      return (0, _loggingUtil.copyLogData)(currentLogData, newProps.logData, defaultLogData);
    }
  }, {
    key: 'render',
    value: function render() {
      var currentUserId = this.props.currentUserDetails && this.props.currentUserDetails.feedUserId.relatedId || null;
      var isCurrentUserTagged = false;
      var currentUserProfile = void 0;
      if (this.props.isCurrentUserTagged && currentUserId) {
        isCurrentUserTagged = true;
        var currentFeedUserId = this.props.currentUserDetails.feedUserId;
        currentUserProfile = _urls2.default.getFeedUserProfileUrl(currentFeedUserId.type, currentFeedUserId.relatedId);
      }

      var otherUserName = void 0;
      var otherUserProfileUrl = void 0;
      var otherUserId = void 0;

      var topTaggedFeedUsers = this.props.topTaggedFeedUsers || [];
      var topOtherUser = topTaggedFeedUsers.find(function (user) {
        return user.feedUserId.type !== _feedUserType2.default.User || user.feedUserId.relatedId !== currentUserId;
      });

      if (topOtherUser) {
        otherUserName = _feedUserUtil2.default.getFeedUserName(topOtherUser);
        otherUserProfileUrl = _urls2.default.getFeedUserProfileUrl(topOtherUser.feedUserId.type, topOtherUser.feedUserId.relatedId);
        otherUserId = topOtherUser.feedUserId;
      }

      return _react2.default.createElement(
        'span',
        { className: 'tag-summary' },
        _react2.default.createElement(_tagSummary2.default, {
          communityContentIdObject: this.props.communityContentIdObject,
          currentUserIsTagged: isCurrentUserTagged,
          currentUserProfileUrl: currentUserProfile,
          currentUserId: this.props.currentUserDetails && this.props.currentUserDetails.feedUserId,
          logData: this.state.logData,
          otherUserName: otherUserName,
          otherUserProfileUrl: otherUserProfileUrl,
          otherUserId: otherUserId,
          totalTaggedUsers: this.props.aggregateUserTagCount,
          showOthers: this.onShowOthers,
          onCloseModal: this.onHideOthers,
          openMiniProfile: this.props.openMiniProfile,
          miniProfileEnabled: this.props.miniProfileEnabled,
          feedContentId: this.props.feedContentId,
          taggedUsersModalEnabled: this.props.taggedUsersModalEnabled,
          topTaggedFeedUsers: this.props.topTaggedFeedUsers }),
        _react2.default.createElement(_connectedTagDetailsModal2.default, {
          communityContentIdObject: this.props.communityContentIdObject,
          currentUserIsTagged: isCurrentUserTagged,
          logData: this.state.logData,
          onCloseModal: this.onHideOthers,
          showModal: this.state.showDetailsModal })
      );
    }
  }]);

  return ConnectedTags;
}(_react.PureComponent);

ConnectedTags.propTypes = {
  communityContentIdObject: spt.CommunityContentId.isRequired,
  currentUserDetails: _react.PropTypes.shape({
    feedUserId: spt.FeedUserId.isRequired
  }),
  feedContentId: _react.PropTypes.string,
  fetchTagUsersIfNeeded: _react.PropTypes.func.isRequired,
  fetchCurrentUserDetailsIfNeeded: _react.PropTypes.func.isRequired,
  fetchCommunityContentMetadataIfNeeded: _react.PropTypes.func.isRequired,
  logData: _react.PropTypes.object.isRequired,
  isCurrentUserTagged: _react.PropTypes.bool,
  aggregateUserTagCount: _react.PropTypes.number.isRequired,
  topTaggedFeedUsers: _react.PropTypes.arrayOf(spt.FeedUser),
  openMiniProfile: _react.PropTypes.func.isRequired,
  miniProfileEnabled: _react.PropTypes.bool,
  taggedUsersModalEnabled: _react.PropTypes.bool
};
ConnectedTags.defaultProps = {
  logData: {},
  topTaggedFeedUsers: []
};


function mapStateToProps(state, ownProps) {
  var communityContentIdObject = ownProps.communityContentIdObject,
      feedContentId = ownProps.feedContentId,
      _ownProps$miniProfile = ownProps.miniProfileEnabled,
      miniProfileEnabled = _ownProps$miniProfile === undefined ? false : _ownProps$miniProfile,
      _ownProps$openMiniPro = ownProps.openMiniProfile,
      openMiniProfile = _ownProps$openMiniPro === undefined ? function () {} : _ownProps$openMiniPro,
      _ownProps$taggedUsers = ownProps.taggedUsersModalEnabled,
      taggedUsersModalEnabled = _ownProps$taggedUsers === undefined ? true : _ownProps$taggedUsers;

  var _ref = communityContentIdObject || {},
      communityContentType = _ref.type,
      communityContentRelatedId = _ref.relatedId;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var currentUser = state.userDetails.currentUser;

  var currentUserDetails = currentUser.details;

  if (!state.tags.contentTags[communityContentIdKey]) {
    return {
      aggregateUserTagCount: 0,
      currentUserDetails: null,
      miniProfileEnabled: miniProfileEnabled,
      openMiniProfile: openMiniProfile,
      feedContentId: feedContentId,
      isCurrentUserTagged: false,
      topTaggedFeedUsers: []
    };
  }

  var _state$tags$contentTa = state.tags.contentTags[communityContentIdKey],
      aggregateUserTagCount = _state$tags$contentTa.aggregateUserTagCount,
      isCurrentUserTagged = _state$tags$contentTa.isCurrentUserTagged,
      topTaggedFeedUsers = _state$tags$contentTa.topTaggedFeedUsers;


  return {
    aggregateUserTagCount: aggregateUserTagCount,
    currentUserDetails: currentUserDetails,
    miniProfileEnabled: miniProfileEnabled,
    openMiniProfile: openMiniProfile,
    feedContentId: feedContentId,
    isCurrentUserTagged: isCurrentUserTagged,
    topTaggedFeedUsers: topTaggedFeedUsers,
    taggedUsersModalEnabled: taggedUsersModalEnabled
  };
}

function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    fetchTagUsersIfNeeded: _actionCreators.fetchTagUsersIfNeeded,
    fetchCurrentUserDetailsIfNeeded: _actionCreators.fetchCurrentUserDetailsIfNeeded,
    fetchCommunityContentMetadataIfNeeded: _actionCreators.fetchCommunityContentMetadataIfNeeded
  }, dispatch);
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConnectedTags);